import {advanceExperiment,initialExperiment,type ExperimentConfig,type ExperimentState} from './measurement-engine';
import {immersion,isMeter,isProbe,type LabItem,type PipetteTransfer} from './mini-lab-mechanics';

export type MeterSession={signature:string;state:ExperimentState};
export type MeterSessions=Record<string,MeterSession>;
/** Translate physical contacts into the existing engine's actions, never into a calculated reading. */
export function syncLabMeters(config:ExperimentConfig,items:LabItem[],previous:MeterSessions,now:number,transfer?:PipetteTransfer):MeterSessions{
 const next:MeterSessions={};let changed=false;
 for(const meter of items.filter(isMeter)){
  const probe=items.find(p=>isProbe(p)&&p.connectedTo===meter.id),vessel=probe&&immersion(items,probe);
  const stirrer=vessel&&items.find(i=>i.id===vessel.parentId&&i.kind==='stirrer');
  const stirring=!!stirrer?.running&&items.some(i=>i.kind==='bar'&&i.parentId===vessel?.id);
  const flowing=!!vessel&&(transfer?.status==='running'&&(transfer.targetId===vessel.id||transfer.sourceId===vessel.id));
  const signature=[probe?.id??'',vessel?.id??'',vessel?.solutionId??'',flowing?'flow':vessel?.volume??0,stirring].join('|');
  const old=previous[meter.id];
  if(old?.signature===signature){next[meter.id]=old;continue;}
  let state=old?.state??initialExperiment(config);
  if(state.immersed)state=advanceExperiment(config,state,{type:'immerse',active:false},now);
  if(state.sensor!==meter.kind)state=advanceExperiment(config,state,{type:'sensor',quantity:meter.kind as 'ph'|'conductivity'},now);
  if(vessel?.solutionId)state=advanceExperiment(config,state,{type:'select',solutionId:vessel.solutionId},now);
  if(state.stirring!==stirring)state=advanceExperiment(config,state,{type:'stir',active:stirring},now);
  if(vessel?.solutionId&&!flowing)state=advanceExperiment(config,state,{type:'immerse',active:true},now);
  next[meter.id]={signature,state};changed=true;
 }
 return changed||Object.keys(previous).length!==Object.keys(next).length?next:previous;
}
